<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<div class="main-div">
    <div class="image">
        <img src="/images/Artist/section4.png" alt="" width="100%" height="100%">
    </div>
    <div class="onediv">
        <p>4</p>
    </div>
    <div class="virtualhead">
        <p>Character, <br>Virtual MuA &<br> Animation Artists</p>
    </div>
    <div class="text2-div">
        <p>
            Life is about motion and humans are about intricate details. You put life into a scene through utilizing your deep understanding of organic anatomy and motion to build realer than life characters. You put the personality into a person. 
            <br>
            <br>
            <span style="font-weight: 600;">
                We’re building the future where you will build armies with each soldier having unique personal traits rather than one character a week. 
            </span>
            <br>
            <br>
            Join us for a sneak peek on what it is like and while you’re there, show off your latest creations and voice your opinion on what you would like to see added to that future.
        </p>
    </div>
    <div class="button">
        <DesktopButton2 
        state = "Artists & Musicians"
        text1 = "Join Visual Art Governance Council"
        text2 = "(Character Seat)"
        text3 = 25
        TextColor = "black"
        TextColor2 = "black"
        BorderColorBefore = '0.093vh solid black'
        BorderColorAfter = '0.093vh solid aqua'
        TextColorAfter = 'black'
        AnimationColor = 'aqua'
         />
    </div>
    <div class="scroll_div">
        <p class="scrollText" >scroll / drag</p>
        <svg
            width="6.185vh"
            height="0.741vh"
            viewBox="0 0 72 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="img"
        >
            <path
                d="M71.3536 4.35355C71.5488 4.15829 71.5488 3.84171 71.3536 3.64645L68.1716 0.464466C67.9763 0.269204 67.6597 0.269204 67.4645 0.464466C67.2692 0.659728 67.2692 0.976311 67.4645 1.17157L70.2929 4L67.4645 6.82843C67.2692 7.02369 67.2692 7.34027 67.4645 7.53553C67.6597 7.7308 67.9763 7.7308 68.1716 7.53553L71.3536 4.35355ZM0 4.5H71V3.5H0V4.5Z"
            />
        </svg>
    </div>
</div>

<style>
    p{
        margin: 0;
        font-family: 'Orbitron';
    }
.main-div{
    height:100vh;
    width:165.370vh;
    position: relative;
}
.image{
    position: absolute;
    left:4.074vh ;
    width: 81.481vh;
}
.image::after{
        position: absolute;
        content: "";
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 0, 0, 0)(255, 255, 255);
    }
.onediv {
    font-size: 55.556vh;
    color: #f4eeec;
    font-weight: 700;
    position: absolute;
    left: 52.407vh;
    opacity: 50%;
    line-height: 55.556vh ;
    }
    .virtualhead{
        font-weight: 700;
        font-size: 5.556vh ;
        line-height: 5.556vh ;
        text-transform: uppercase;
        color: #000000;
        position: absolute;
        left: 67.963vh ;
        top: 24.352vh ;
    }
    .text2-div p{
        font-size: 1.852vh ;
        font-weight: 400;
        line-height: 2.593vh ;
        color: #000000;
        letter-spacing: 0.12vh;
        position: absolute;
        left: 89.259vh;
        top: 46.481vh;
        width: 66.019vh;
    }
    .button{
        position: absolute;
        top: 85vh;
        left: 89.259vh;
    }
    .scroll_div {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 3.704vh;
        left: 141.204vh;
    }
    .scroll_div .scrollText {
        font-size: 1.481vh;
        font-weight: 700;
        line-height: 1.857vh;
        font-family: "Orbitron";
        text-transform: capitalize;
        color: black;
    }
    .scroll_div .img {
        margin-left: 1.778vh;
        width: 6.185vh;
        height: 0.741vh;
        fill: black;
    }
</style>